import { postCheckUsernameSso } from '../services';

export default function useCheckUsernameSso(
  userName,
  setAllowPasswordLogin,
  setError,
  csrfToken,
) {
  async function postCheckSso() {
    setError('');
    try {
      const response = await postCheckUsernameSso(csrfToken, userName);

      const parsedResponse = await response.json();

      if (parsedResponse.allow_password_login) {
        setAllowPasswordLogin(true);
      } else if (parsedResponse.requires_sso) {
        window.location.href = parsedResponse.redirect_url || '/';
      }
    } catch (error) {
      setError(error);
    }
  }

  return {
    postCheckSso,
  };
}
